module.exports = __webpack_public_path__ + "img/saving-es.647e040a.png";